<template>
    <div class="toasts" id="toasts">
        <transition-group name="toasts-transition"  class="toasts-container" tag="div">
            <Toast
                v-for="toast in toasts"
                :key="toast.id"
                :toast="toast"
            />
        </transition-group>
    </div>
</template>

<script>
import Toast from '~/components/toasts/Toast.vue'

export default {
    components: {
        Toast
    },

    beforeMount () {
        // New toast from server
        this.$socket.on('toast', this.serverToast)
    },

    computed: {
        toasts () {
            return this.$toastStore.toasts
        }
    },

    methods: {
        serverToast(data) {
            let library = data.library;

            let toast = {
                title:       data.title ? this.$t(data.title, library) : '',
                text:        data.text ? this.$t(data.text, library) : '',

                image:       data.image       || null,
                icon:        data.icon        || null,
                userImage:   data.userImage   || false,

                closable:    data.closable    || true,
                autoClose:   data.autoClose   || false,

                action:      data.action      || null,
                link:        data.link        || null,
                reload:      data.reload      || null,
                actionTitle: data.actionTitle ? this.$t(data.actionTitle, library) : 'Дія',
            }

            this.$toastStore.add(toast);
        }
    },

    destroyed () {
        this.$socket.off('toast', this.serverToast)
    }
}
</script>

<style scoped lang="postcss">
.toasts {
    position: fixed;
    top: calc(0px + env(safe-area-inset-top));
    right: 0;
    left: 0;
    z-index: 99999; 

    margin: 16px 14px;
}

.toasts-container {
    position: relative;
    width: 100%;
    max-height: 100vh;

    -webkit-overflow-scrolling: touch;


    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;  
        height: 0;
        width: 0;
    }
}

.toasts-transition-enter,
.toasts-transition-leave-to {
    opacity: 0;
    transform: translate(0, -100%);
}

.toasts-transition-leave-active {
    position: absolute !important;
}

@media (min-width: 576px)  {
    .toasts {
        left: auto;
        width: 390px;
        margin: 24px 24px 0 0;
        padding: 0;

        .toast {
            margin: 0 0 16px;
        }
    }

    .toasts-transition-enter,
    .toasts-transition-leave-to {
        transform: translate(100%, 0);
    }
}
</style>
